import { PageSize } from '@/constant';
import { TGetDataSearchFilter } from '@/services';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '..';
import {
	IPayloadGetPublicSalaryApplicantListRequest,
	IPayloadGetPublicSalaryApplicantListSuccess,
	IPayloadGetPublicSalaryDetailRequest,
	IPayloadGetPublicSalaryDetailSuccess,
	IPayloadGetPublicSalaryExcelListRequest,
	IPayloadGetPublicSalaryListRequest,
	IPayloadGetPublicSalaryListSuccess,
	IPublicSalaryApplicantListDetailStore,
	IPublicSalaryDetailStore,
	IPublicSalaryListDetailStore,
} from './worker-public-salary.type';

const InitParams: TGetDataSearchFilter = {
	page: 1,
	pageSize: PageSize.S,
	searchTypes: [],
};

const initialState = {
	fetching: false,
	excelListFetching: false,
	publicSalaryList: [] as IPublicSalaryListDetailStore[],
	total: 0,
	totalData: null as any,
	params: InitParams,

	detailFetching: false,
	publicSalaryDetail: {} as IPublicSalaryDetailStore,

	applicantFetching: false,
	applicantList: [] as IPublicSalaryApplicantListDetailStore[],
	applicantTotal: 0,
	applicantParams: InitParams,
};

const workerPublicSalarySlice = createSlice({
	initialState,
	name: 'workerPublicSalary',
	reducers: {
		/**---- GET PUBLIC SALARY LIST START ---- */
		getPublicSalaryListRequest: (
			state,
			action: PayloadAction<IPayloadGetPublicSalaryListRequest>
		) => {
			state.fetching = true;
			state.params = action.payload;
		},
		getPublicSalaryListSuccess: (
			state,
			action: PayloadAction<IPayloadGetPublicSalaryListSuccess>
		) => {
			const { content, total, totalData, page, pageSize, sortSql, allData } =
				action.payload;
			state.fetching = false;
			state.publicSalaryList = content;
			state.total = total;
			state.totalData = totalData;
			state.params = {
				...state.params,
				page,
				pageSize,
				sortSql,
				allData,
			};
		},
		getPublicSalaryListFailure: (state) => {
			state.fetching = false;
			state.total = 0;
			state.totalData = null;
			state.publicSalaryList = [];
		},
		/**---- GET PUBLIC SALARY LIST END ---- */

		/**---- GET PUBLIC SALARY EXCEL LIST START ---- */
		getPublicSalaryExcelListRequest: (
			state,
			action: PayloadAction<IPayloadGetPublicSalaryExcelListRequest>
		) => {
			state.excelListFetching = true;
		},
		getPublicSalaryExcelListSuccess: (state) => {
			state.excelListFetching = false;
		},
		getPublicSalaryExcelListFailure: (state) => {
			state.excelListFetching = false;
		},
		/**---- GET PUBLIC SALARY EXCEL LIST END ---- */

		/**---- GET PUBLIC SALARY DETAIL START ---- */
		getPublicSalaryDetailRequest: (
			state,
			action: PayloadAction<IPayloadGetPublicSalaryDetailRequest>
		) => {
			state.detailFetching = true;
		},
		getPublicSalaryDetailSuccess: (
			state,
			action: PayloadAction<IPayloadGetPublicSalaryDetailSuccess>
		) => {
			state.detailFetching = false;
			state.publicSalaryDetail = action.payload.publicSalaryDetail;
		},
		getPublicSalaryDetailFailure: (state) => {
			state.detailFetching = false;
		},
		/**---- GET PUBLIC SALARY DETAIL END ---- */

		/**---- GET PUBLIC SALARY LIST START ---- */
		getPublicSalaryApplicantListRequest: (
			state,
			action: PayloadAction<IPayloadGetPublicSalaryApplicantListRequest>
		) => {
			state.applicantFetching = true;
			state.applicantParams = action.payload;
		},
		getPublicSalaryApplicantListSuccess: (
			state,
			action: PayloadAction<IPayloadGetPublicSalaryApplicantListSuccess>
		) => {
			const { content, total } = action.payload;
			state.applicantFetching = false;
			state.applicantList = content;
			state.applicantTotal = total;
		},
		getPublicSalaryApplicantListFailure: (state) => {
			state.applicantFetching = false;
			state.applicantTotal = 0;
			state.applicantList = [];
		},
		/**---- GET PUBLIC SALARY LIST END ---- */
	},
});

export const WorkerPublicSalaryActions = workerPublicSalarySlice.actions;
export const WorkerPublicSalaryReducer = workerPublicSalarySlice.reducer;

export const WorkerPublicSalarySelectors = {
	selectFetching: (state: RootState) => state.workerPublicSalary.fetching,
	selectTotal: (state: RootState) => state.workerPublicSalary.total,
	selectTotalData: (state: RootState) => state.workerPublicSalary.totalData,
	selectParams: (state: RootState) => state.workerPublicSalary.params,
	selectList: (state: RootState) => state.workerPublicSalary.publicSalaryList,
	selectDetail: (state: RootState) =>
		state.workerPublicSalary.publicSalaryDetail,
	selectExcelListFetching: (state: RootState) =>
		state.workerPublicSalary.excelListFetching,

	selectApplicantFetching: (state: RootState) =>
		state.workerPublicSalary.applicantFetching,
	selectApplicantList: (state: RootState) =>
		state.workerPublicSalary.applicantList,
	selectApplicantTotal: (state: RootState) =>
		state.workerPublicSalary.applicantTotal,
	selectApplicantParams: (state: RootState) =>
		state.workerPublicSalary.applicantParams,
};
